<template>
  <div class="user">
    <div class="user-header">
       <div class="flex"> 
         <i class="el-icon-user icon" style="margin-right: 20px;"></i>
         <span class="user-header-title" style="margin-right: 5px;">AIMICS</span>
         <span class="user-header-title lo">|</span>
         <span class="user-header-title ftit">人员管理工具</span>
        </div>
       <div class="flex">
        <div class="view-icon icc"></div>
        <span class="header-title">视图</span>
        <div class="support-icon"></div>
        <span class="header-title">支持</span>
        <div class="application-icon"></div>
        <span class="header-title" style="margin-right: 80px;">应用</span>
        <div @click="goOut" class="usertou-icon"></div>
        <span class="header-title">zhaoyipeng</span>
        <div @click="goOut" class="out-icon"></div>
       </div>
       
    </div>
    <div class="user-box">
      <div class="user-menu">
        <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </div>
      <div class="user-content">
        <el-row :gutter="20" style="margin-bottom: 20px;">
          <el-col :span="2">
           <div class="flex">
            <div  class="search-title"><span>姓名：</span></div> 
            <el-input size="mini" v-model="test"></el-input>
           </div>
          </el-col>
          <el-col :span="2">
           <div class="flex">
            <div  class="search-title"><span>性别：</span></div> 
            <el-input size="mini" v-model="test"></el-input>
           </div>
          </el-col>
          <el-col :span="3">
           <div class="flex">
            <div class="search-title" style="width: 130px;"><span>出生日期：</span></div> 
            <el-input size="mini" v-model="test" ></el-input>
           </div>
          </el-col>
          <el-col :span="2" >
           <div class="flex">
            <div  class="search-title"><span>民族：</span></div> 
            <el-input size="mini" v-model="test"></el-input>
           </div>
          </el-col>
          <el-col :span="2">
           <div class="flex">
            <div class="search-title"><span>籍贯：</span></div> 
            <el-input size="mini" v-model="test"></el-input>
           </div>
          </el-col>
          <el-col :span="4">
           <div class="flex">
            <div class="search-title"><span>单位：</span></div> 
            <el-input size="mini" v-model="test"></el-input>
           </div>
          </el-col>
         
          <el-col :span="2">
           <div class="flex">
            <div class="search-title"><span>岗位：</span></div> 
            <el-input size="mini" v-model="test"></el-input>
           </div>
          </el-col>
          <el-col :span="2">
           <div class="flex">
            <div class="search-title"><span>职务：</span></div> 
            <el-input size="mini" v-model="test"></el-input>
           </div>
          </el-col>
        </el-row>
        <div class="flex user-content-main-box">
           <div class="user-content-main-box-right">
            <el-table
            size="mini"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            :header-cell-style="{
            background: '#343434',
            color: '#c7c7c9',
            border: '1px solid #4e4c4c',
       }"
    :data="tableData"
    stripe 
    style="width: 100%">
    <el-table-column
      prop="date"
      label="日期"
      width="100">
    </el-table-column>
    <el-table-column
      prop="name"
      label="姓名"
      width="100">
    </el-table-column>
    <el-table-column
      prop=""
      label="手机号">
    </el-table-column>
    <el-table-column
      prop=""
      label="性别"
      width="80">
    </el-table-column>
    <el-table-column
      prop=""
      label="民族"
      width="80">
    </el-table-column>
    <el-table-column
      prop=""
      label="籍贯"
      width="80">
    </el-table-column>
    <el-table-column
      prop="address"
      label="地址"
      width="200">
    </el-table-column>
    <el-table-column
      prop=""
      label="单位">
    </el-table-column>
    <el-table-column
      prop=""
      label="岗位"
      width="100">
    </el-table-column>
    <el-table-column
      prop=""
      label="职位"
      width="100">
    </el-table-column>
    <el-table-column
      prop=""
      label="ID"
      width="200">
    </el-table-column>
    <el-table-column
      prop=""
      label="操作">
      <template slot-scope="scope">
          <el-button size="mini" @click="testArrayClick(scope)">详情</el-button>
      </template>
    </el-table-column>
  </el-table>
           </div>
        </div>
      </div>
    </div>
    <div class="box">
    <el-dialog
  title="个人详情"
  :visible.sync="dialogVisible"
  width="50%"
  :before-close="handleClose">
  <div class="content-body"></div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false" size="mini">确 定</el-button>
  </span>
</el-dialog>
</div>
  </div>
</template>

<script>
export default {
    name:'',
    props:[''],
    data () {
      return {
        dialogVisible:false,
        test: '',
        data: [{
          label: '一级 1',
          children: [{
            label: '二级 1-1',
            children: [{
              label: '三级 1-1-1'
            }]
          }]
        }, {
          label: '一级 2',
          children: [{
            label: '二级 2-1',
            children: [{
              label: '三级 2-1-1'
            }]
          }, {
            label: '二级 2-2',
            children: [{
              label: '三级 2-2-1'
            }]
          }]
        }, {
          label: '一级 3',
          children: [{
            label: '二级 3-1',
            children: [{
              label: '三级 3-1-1'
            }]
          }, {
            label: '二级 3-2',
            children: [{
              label: '三级 3-2-1'
            }]
          }]
        }],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路'
        }]
      };
    },

    components: {},

    computed: {},

    mounted() {},

  methods: {
    handleOpen(key, keyPath) {
        console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      this.dialogVisible = false
      console.log(key, keyPath);
    },
    goOut() {
      this.$router.go('-1')
    },
    handleNodeClick(data) {
        console.log(data);
    },
    testArrayClick(scope) {
       this.dialogVisible = true
    },
    arrayTest() {
      let arr1 = [1, 2, 3, 4, 5, 6, 7, 8, 9]
      let arr2 = [{'group':1,'time':'15:03'},{'group':2,'time':'15:04'},{'group':1,'time':'15:03'}]
      arr2.forEach((val,index,a) => {
          console.log(val)
          console.log(index)
          console.log(a)
      })
      let newArray = arr2.map((item,index) => {
          console.log(item)
          return item.group = 0
      })
        console.log(newArray)
      },
    },

  watch: {
      
    }
     
  }

</script>
<style  scoped>
.box >>> .el-dialog{
  background: #4c4b4cda !important;
}
.box >>> .el-dialog__header{
  color: #fff !important;
}
.box >>> .el-dialog__title {
  color: #fff !important;
  font-size: 15px !important;
}
.box >>> .slot-scope{
   margin-top: 50px;
}
.content-body{
  width: 100%;
  height: 500px;
}
  .flex{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .user{
    height: 100%;
    background-color: #303235;
    overflow: hidden;
  }
  .user-header{
    padding: 0 20px 0 20px;
    height: 37px;
    background-color: #4d5156;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    color: aliceblue;
    font-size: 1.7vh;
    font-weight: 700;
    border-bottom: 2px solid #4c4b4c;
  }
  .lo{
    font-size: 2vh;
    margin-right: 5px;
  }

  .ftit{
    font-size: 1.6vh;
  }
  .user-box{
    height: calc(100% - 37px);
    display: flex;
    flex:1;
    flex-direction: row;
  }
  .user-menu{
    width: 350px;
    border-right: 1px solid #4c4b4c;
    background-color: #4d5156;
    padding: 10px;
  }
  .user-content{
    flex: 1;
    margin: 5px;
    overflow: auto;
    background-color: #303235;
    padding: 10px;
  }
  .icon{
    font-size: 2vh;
    cursor: pointer;
  }
  .user-menu >>> .el-menu{
    border-right: 1px solid transparent !important;
  }
  .user-menu >>> .el-tree{
    background: transparent !important;
    color: #fff !important;
  }
  .out-icon{
    width: 18px;
    height: 18px;
    background-image: url('../../../assets/退出.png');
    background-size: 100% 100%;
    cursor: pointer;
  }
  .usertou-icon{
    width: 18px;
    height: 18px;
    background-image: url('../../../assets/user.png');
    background-size: 100% 100%;
    margin-right: 10px;
  }
  .search-title{
    width: 80px;
    color: rgb(255, 255, 255);
  }
</style>
<style scoped lang="less">
  .icc{
    width: 22px;
    height: 22px;
    background-size: 100% 100%;
    margin-right: 10px;
  }
.view-icon{
  background-image: url('../../../assets/keshihua.png');
}
.support-icon{
  width: 20px;
    height: 20px;
    background-size: 100% 100%;
    margin-right: 10px;
  background-image: url('../../../assets/服务中心.png');
}
.application-icon{
  width: 18px;
  height: 18px;
  background-size: 100% 100%;
  margin-right: 10px;
  background-image: url('../../../assets/服务.png');
}
.header-title{
  font-weight: 100;
  font-size: 1.4vh;
  margin-right: 20px;
}
.user-content-main-box{
  width: 100%;
  height: 86%;
  flex: 1;
  margin-top: 1%;
  .user-content-main-box-right{
    display: flex;
    flex: 1;
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/other/userShow/index.vue